var map = {
	"./assets/clickable/vimeo.svg": "9893cb18ce7113d9e775",
	"./assets/disabled/vimeo.svg": "a709736e9ae68ffbfefb",
	"./assets/original/vimeo.svg": "212595f4477022e684b8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bcedfdf413a2854395f5";